import useJwt from '@/modules/statute/jwt'
import * as types from './mutation-types'

// eslint-disable-next-line import/prefer-default-export
export const ActionSetNewSuggestions = async ({ dispatch }, payload) => {
  const api = await useJwt.addSuggestions(payload)
  return api
}
